module.exports = __webpack_public_path__ + "static/images/sidebar/no-results.svg";